export const listLang = [
    { text: 'English', flag: '../../../assets/img/flag/usa.png', lang: 'en' },
    {
        text: 'Chinese',
        flag: '../../../assets/img/flag/chinese.jpg',
        lang: 'zh-Hant',
    }, // (zh-Hant Chinese traditional)
];

export const languages = [{ name: 'English', value: 'English' }];
